// TODO: rename to workflowStatusAndNote
import angular from 'angular'
import directive from './directive'

export default angular
  .module('ellipsis.webskedButtons', [])
  .directive('webskedButtons', [directive])
